<div class="header-wrapper">
  <mat-toolbar color="primary">
    <span class="header-item"><a routerLink="/customer">KSVS</a></span>
    <span class="spacer"></span>
    <span class="header-item"><a routerLink="/customer">Kunden</a></span>
    <span class="header-item"><a routerLink="/system">Systeme</a></span>
    <span class="header-item"><a routerLink="/contract">Verträge</a></span>
    <span class="header-item"><a routerLink="/translation">Übersetzungen</a></span>
    <span class="header-item"><a routerLink="/app-storage">App-Builds</a></span>
  </mat-toolbar>
</div>
<div class="content">
  <mat-card>
    <mat-card-content>
      <router-outlet></router-outlet>
    </mat-card-content>
  </mat-card>
</div>
